import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BRAND_NAME } from '../config/brand';

// Regras avaliadas em ordem; a primeira que casar com o pathname define o título.
const PAGE_TITLES = [
  { test: (p) => p === '/' || p === '/dashboard', title: 'Dashboard' },
  { test: (p) => p.startsWith('/product'), title: 'Produtos' },
  { test: (p) => p.startsWith('/coupom'), title: 'Cupons' },
  { test: (p) => p.startsWith('/schools/management'), title: 'Gestao Escolar' },
  { test: (p) => p.startsWith('/schools'), title: 'Escolas' },
  { test: (p) => p.startsWith('/students'), title: 'Alunos' },
  { test: (p) => p.startsWith('/community'), title: 'Comunidade' },
  { test: (p) => p.startsWith('/course'), title: 'Cursos' },
  { test: (p) => p.startsWith('/members'), title: 'Area de Membros' },
  { test: (p) => p.startsWith('/orders') || p.startsWith('/order/'), title: 'Vendas' },
  { test: (p) => p.startsWith('/bookings') || p.startsWith('/booking/'), title: 'Reservas' },
  { test: (p) => p.startsWith('/abandoned/cart'), title: 'Carrinhos Abandonados' },
  { test: (p) => p.startsWith('/subscriptions') || p.startsWith('/subscription/'), title: 'Assinaturas' },
  { test: (p) => p.startsWith('/affiliate'), title: 'Afiliados' },
  { test: (p) => p.startsWith('/finance'), title: 'Financeiro' },
  { test: (p) => p.startsWith('/reports'), title: 'Relatorios' },
  { test: (p) => p.startsWith('/analytics'), title: 'Metricas' },
  { test: (p) => p.startsWith('/integrations/webhooks'), title: 'Webhooks' },
  { test: (p) => p.startsWith('/integrations/enotas'), title: 'eNotas' },
  { test: (p) => p.startsWith('/integrations/notifications'), title: 'Notificacoes' },
  { test: (p) => p.startsWith('/integrations/whatsapp'), title: 'WhatsApp' },
  { test: (p) => p.startsWith('/integrations/chatbot'), title: 'Chatbot' },
  { test: (p) => p.startsWith('/integrations'), title: 'Integracoes' },
  { test: (p) => p.startsWith('/admin/products'), title: 'Administracao - Produtos' },
  { test: (p) => p.startsWith('/admin/orders'), title: 'Administracao - Vendas' },
  { test: (p) => p.startsWith('/admin/subscriptions'), title: 'Administracao - Assinaturas' },
  { test: (p) => p.startsWith('/admin/categories'), title: 'Administracao - Categorias' },
  { test: (p) => p.startsWith('/batch-payment'), title: 'Pagamentos em Lote' },
  { test: (p) => p.startsWith('/support') || p.startsWith('/help'), title: 'Suporte' },
  { test: (p) => p.startsWith('/tickets'), title: 'Minhas Solicitacoes' },
  { test: (p) => p.startsWith('/account'), title: 'Minha Conta' },
  { test: (p) => p.startsWith('/myorders'), title: 'Minhas Compras' },
  { test: (p) => p.startsWith('/login') || p.startsWith('/active/'), title: 'Login' },
  { test: (p) => p.startsWith('/register'), title: 'Cadastro' },
  { test: (p) => p.startsWith('/forgot'), title: 'Recuperar Senha' },
  { test: (p) => p.startsWith('/kyc'), title: 'Verificacao KYC' },
  { test: (p) => p.startsWith('/privacy-policies'), title: 'Politica de Privacidade' },
  { test: (p) => p.startsWith('/terms-of-use') || p.startsWith('/terms-and-policies'), title: 'Termos de Uso' },
  { test: (p) => p.startsWith('/customer/subscription/invoice'), title: 'Fatura' },
  { test: (p) => p === '/404', title: 'Pagina nao encontrada' },
];

// Define document.title como "{BRAND_NAME} - {titulo da pagina}" a cada troca de rota.
const DocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    // Checkout.page.js define seu proprio titulo (nome do produto); nao sobrescrever aqui.
    if (pathname.startsWith('/checkout')) return;

    const match = PAGE_TITLES.find(({ test }) => test(pathname));
    document.title = match ? `${BRAND_NAME} - ${match.title}` : BRAND_NAME;
  }, [location.pathname]);

  return null;
};

export default DocumentTitle;
